module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-9f36ff372562f3c99987fc2b33167348.webp";